import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLang } from "../LanguageContext";

const FEATURE_IMG =
  "https://customer-assets-4nw71qhi.emergentagent.net/job_ecole-pleine-nature/artifacts/j4iemtqg_circle.webp";

export default function Comprendre() {
  const { t } = useLang();
  const sections = t("comprendre.sections") || [];

  return (
    <div data-testid="page-comprendre">
      <section className="container-page pt-16 sm:pt-24 pb-10">
        <p className="eyebrow mb-4">{t("comprendre.eyebrow")}</p>
        <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-medium text-ink max-w-3xl leading-tight">
          {t("comprendre.title")}
        </h1>
        <p className="mt-6 text-lg text-ink-muted leading-relaxed max-w-2xl">
          {t("comprendre.intro")}
        </p>
      </section>

      <section className="container-page pb-12">
        <div className="grid grid-cols-1 md:grid-cols-[minmax(0,20rem)_minmax(0,1fr)] gap-8 md:gap-12 items-stretch max-w-4xl mx-auto">
          <div className="rounded-[2rem] overflow-hidden shadow-soft bg-cream-100">
            <img
              src={FEATURE_IMG}
              alt="École Pleine Nature — temps collectif en cercle"
              className="w-full h-full object-cover block"
              loading="lazy"
            />
          </div>

          <aside
            className="rounded-[2rem] bg-earth/10 border border-earth/20 px-7 sm:px-8 py-8 flex flex-col justify-between gap-6"
            data-testid="comprendre-formation-banner"
          >
            <h3 className="font-heading text-xl sm:text-2xl text-ink font-medium leading-snug break-words">
              {t("comprendre.formation_q")}
            </h3>
            <Link to="/formation" className="btn-primary self-start" data-testid="comprendre-cta-formation">
              {t("comprendre.formation_cta")} <ArrowRight size={18} />
            </Link>
          </aside>
        </div>
      </section>

      <section className="container-page pb-12">
        <div className="grid lg:grid-cols-2 gap-5 sm:gap-7">
          {sections.map((s) => (
            <article key={s.n} className="card-soft p-8 sm:p-10 flex gap-5" data-testid={`comprendre-${s.n}`}>
              <div className="shrink-0 font-accent text-3xl text-earth leading-none pt-1">{s.n}</div>
              <div>
                <h2 className="font-heading text-xl sm:text-2xl font-semibold text-ink mb-3">{s.title}</h2>
                <p className="text-ink-muted leading-relaxed">{s.text}</p>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section className="container-page py-16">
        <div className="rounded-[2.5rem] bg-forest-light/70 px-8 sm:px-14 py-14 text-center">
          <h3 className="font-heading text-2xl sm:text-3xl text-ink font-medium max-w-2xl mx-auto">
            {t("comprendre.cta_title")}
          </h3>
          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link to="/inscrire" className="btn-primary" data-testid="comprendre-cta-inscrire">
              {t("comprendre.cta_inscrire")} <ArrowRight size={18} />
            </Link>
            <Link to="/pratique" className="btn-secondary" data-testid="comprendre-cta-pratique">
              {t("comprendre.cta_pratique")}
            </Link>
            <Link to="/contact" className="btn-outline" data-testid="comprendre-cta-contact">
              {t("comprendre.cta_contact")}
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
